<template>
  <div :class="$style.wrapper">
    <div :class="$style.back"></div>
    <div :class="$style.left">
      <p>Посмотри, какие существуют профессии в IT для <br> работы с беспилотными технологиями.</p>
      <div :class="$style.list">
        <div
          v-for="(item, index) in data"
          :class="$style.item"
          :key="index"
          @click="() => open(item)"
        >
          <div :class="$style.icon" :style="{ backgroundImage: `url(${item.icon})` }"></div>
          <div :class="$style.title">{{item.title}}</div>
        </div>
      </div>
    </div>
    <v-btn :class="$style.btn" @click="() => $emit('success')">Далее</v-btn>
    <div :class="[$style.popup, opened && $style.opened]" @click.self="close">
      <div :class="$style.inner" v-if="selected">
        <div :class="$style.icon" :style="{ backgroundImage: `url(${selected.icon})` }"></div>
        <h2>{{selected.title}}</h2>
        <p>{{selected.text}}</p>
        <div :class="$style.button">
          <v-btn @click="close" wider>Понятно</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import data from './data'

export default {
  name: 'professions',
  data: () => ({
    data,
    opened: false,
    selected: null,
  }),
  methods: {
    open(item) {
      this.opened = true
      this.selected = item
    },
    close() {
      this.opened = false
    },
  },
}
</script>
<style lang="scss" module>
.wrapper {
  background: #fff;
  padding: 2rem;
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;

  .btn {
    position: absolute;
    right: 3.5rem;
    top: 5rem;
    min-width: 17.2rem;
  }
}

.left {
  background: #fff;
  position: relative;
  z-index: 5;
  width: 91.5rem;
  box-shadow: 0px 0px 0.8rem rgba(0, 0, 0, 0.15);
  border-radius: 1rem;
  padding: 4rem;

  h2 {
    font-size: 2.4rem;
    line-height: 1.375;
    margin: 0;
    margin-bottom: 0.5rem;
  }

  p {
    font-size: 2.4rem;
    line-height: 1.375;
    margin: 0;
  }
}

.list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin: 0 -2rem;
  margin-top: 1rem;
}

.item {
  width: 27rem;
  height: 27rem;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 1rem;
  margin: 1rem;
  position: relative;
  cursor: pointer;
  transition: transform 0.2s ease;
  transform-origin: center;
  padding: 2rem;

  &:hover {
    transform: scale(1.05);
  }

  &:after {
    content: '';
    width: 1.3rem;
    height: 2rem;
    display: block;
    position: absolute;
    background: url(./assets/shevron.svg) no-repeat center;
    background-size: contain;
    bottom: 2rem;
    right: 2rem;
  }

  .title {
    margin-top: 1rem;
    font-size: 1.8rem;
    line-height: 1.3888888889;
  }
}

.icon {
  width: 6.5rem;
  height: 6.5rem;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.back {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  &:after {
    content: '';
    display: block;
    width: 42.75rem;
    height: 34.1rem;
    background: url(./assets/car.png) no-repeat center;
    background-size: contain;
    position: absolute;
    right: 5rem;
    bottom: 10rem;
  }

  &:before {
    content: '';
    display: block;
    width: 59.3rem;
    height: 59.3rem;
    position: absolute;
    right: 0;
    bottom: 0;
    background: url(./assets/circles.svg) no-repeat center;
    background-size: contain;
  }
}

.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background: rgba(#000, 0.2);
  opacity: 0;
  transition: opacity 0.4s ease;
  pointer-events: none;
}

.inner {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 48.4rem;
  padding: 3rem;
  padding-bottom: 6rem;
  background: #fff;
  border-radius: 1rem;
  transform: translate(-50%, -50%)translateY(5rem);
  opacity: 0;
  transition: transform 0.4s ease, opacity 0.4s ease;

  h2 {
    font-size: 2.4rem;
    margin: 0;
    margin-top: 2.5rem;
    margin-bottom: 1.5rem;
    white-space: pre;
  }

  p {
    font-size: 1.8rem;
    line-height: 1.3888888889;
  }
}

.opened {
  opacity: 1;
  pointer-events: auto;

  .inner {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}

.button {
  margin-top: 6rem;
  display: flex;
  justify-content: center;
}
</style>
